import styled from 'styled-components';
import { Form as unformForm } from '@unform/web';

const bgDark = '#121212';
const cardDark = '#1E1E1E';
const textLight = '#EAEAEA';
const border = 'rgba(255,255,255,0.1)';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: ${bgDark};
  color: ${textLight};
  align-items: center;
  width: 100%;
  overflow-x: hidden;
`;

export const Form = styled(unformForm)`
  width: 100%;
  max-width: 1080px;
  margin: 120px auto 0 auto;
  display: flex;
`;

export const Content = styled.div`
  width: 100%;
  max-width: 1080px;
  margin: 24px auto 40px auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`;

export const Title = styled.h1`
  font-size: 28px;
  font-weight: 800;
`;

export const ChartsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  @media (min-width: 1024px) { grid-template-columns: 1fr 1fr; }
`;

// Single-column stack for full-width charts
export const ChartsStack = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
`;

export const ChartCard = styled.div`
  background: ${cardDark};
  border: 1px solid ${border};
  border-radius: 12px;
  padding: 16px;
`;

export const ChartTitle = styled.h3`
  margin: 4px 0 12px 0;
`;

export const ControlsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const Select = styled.select`
  background: #2e2e35;
  color: #b8b8b8;
  border: 2px solid #17171e;
  border-radius: 10px;
  padding: 10px 12px;
  height: 44px;
`;
